export default __webpack_public_path__ + "static/media/library_1_compressed.0f172888.jpg";